import { lazyOverlay } from '@/routing/lazyRoute';

/**
 * T-0559: the terms screen, its own chunk. It is drawn only for an account whose acceptance is
 * outstanding, so a launch of an accepted account never parses it.
 */
export const TermsAcceptanceScreen = lazyOverlay(
  () => import('./TermsAcceptanceScreen'),
  (module) => module.TermsAcceptanceScreen,
);
